<script lang="ts">
	import type { UploadedFile } from "../../../../core/schema/UploadedFile.js";
	import play from "../../../../core/assets/icons/play-button.svg?raw";
	import Icon from "../Icon.svelte";
	import { getSharedGlobalSettings } from "../../getSharedGlobalSettings.js";

	export let video: UploadedFile;
	export let width: number;
	export let height: number;
	export let loop = true;
	export let autoplay = true;
	export let videoClass = "";
	export let icon = false;

	const bucket = "storage";

	const { STORAGE_URL, UPLOAD_URL } = getSharedGlobalSettings();

	$: bucketUrl = {
		storage: STORAGE_URL,
		upload: UPLOAD_URL,
	}[bucket];
</script>

{#if icon}
	<div
		class="absolute inset-0 -z-10 flex items-center justify-center transition-opacity duration-300 group-hover:opacity-0"
	>
		<div
			class="bg-secondary absolute inset-0 left-1/2 top-1/2 h-[calc(100%-0.6rem)] w-[calc(100%-0.6rem)] -translate-x-1/2 -translate-y-1/2 rounded md:h-[calc(100%-1rem)] md:w-[calc(100%-1rem)] md:rounded-lg"
		></div>
	</div>
{/if}
<video {autoplay} {height} {width} {loop} muted playsinline class="{videoClass} z-20">
	<source src="{bucketUrl}/{video.path}#t=0.001" type={video.type} />
</video>
{#if icon}
	<div class="absolute inset-0 flex items-center justify-center transition-opacity duration-300 group-hover:opacity-0">
		<Icon icon={play} class="h-5 w-5 text-gray-300 opacity-80 md:h-6 md:w-6" />
	</div>
{/if}
